class TabsAutomatic {
  constructor(groupNode) {
    this.tablistNode = groupNode;

    this.tabs = [];

    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
    this.tabpanels = [];

    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

      tab.tabIndex = -1;
      tab.setAttribute('aria-selected', 'false');
      this.tabpanels.push(tabpanel);

      tab.addEventListener('keydown', this.onKeydown.bind(this));
      tab.addEventListener('click', this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    }

    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(currentTab, setFocus) {
    if (typeof setFocus !== 'boolean') {
      setFocus = true;
    }
    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        this.tabpanels[i].classList.remove('is-hidden');
        if (setFocus) {
          tab.focus();
        }
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        this.tabpanels[i].classList.add('is-hidden');
      }
    }
  }

  setSelectedToPreviousTab(currentTab) {
    var index;

    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    var index;

    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }

  onKeydown(event) {
    var tgt = event.currentTarget,
        flag = false;

    switch (event.key) {
      case 'ArrowLeft':
        this.setSelectedToPreviousTab(tgt);
        flag = true;
        break;

      case 'ArrowRight':
        this.setSelectedToNextTab(tgt);
        flag = true;
        break;

      case 'Home':
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;

      case 'End':
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

class LightBoxGallery {

  /**
   * @type {{visible: () => boolean, show: () => void, close: () => void, element:() => HTMLElement}}
   */
  instance;

  keyCodes = Object.freeze({
    LEFT: 'ArrowLeft',
    RIGHT: 'ArrowRight',
    ESC: 'Escape'
  });


  /**
   * @type {Array<{element: HTMLElement, instance: {visible: () => boolean, show: () => void, close: () => void, element:() => HTMLElement}}>}
   */
  instances = [];

  /**

   * @param {Array<HTMLElement>} elements
   * @param {(el: HTMLElement) => Element} extractor
   */
  constructor(elements, extractor) {
    this.elements = elements;
    this.extractor = extractor;
    this.listenKeydownEvent = this.listenKeydownEvent.bind(this);
    this.init();
  }

  get isOpen() {
    return this.instance && this.instance.visible();
  }

  init() {
    this.elements.forEach(element => {
      const markup = this.extractor(element);

      if (!markup) {
        return;
      }

      const instance = basicLightbox.create(markup, {
        onShow: () => this.attachOpenEvents(),
        onClose: () => this.detachOpenEvents(),
      });

      this.instances.push({element, instance});

      element.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.instance = instance;
        this.open();
      });
    });
  }


  open() {
    this.instance?.show();
  }

  close() {
    this.instance?.close();
  }

  previous() {
    console.warn('previous');
  }

  next() {
    let index = this.currentIndex();

    if (index + 1 >= this.instances.length) {
      index = -1;
    }

    ++index;
    const record = this.instances[index];

    if (!record) {
      return;
    }

    this.switchInstance(this.instance, record.instance);
  }

  /**
   *
   * @param  {{visible: () => boolean, show: () => void, close: () => void, element:() => HTMLElement}} old
   * @param  {{visible: () => boolean, show: () => void, close: () => void, element: () =>HTMLElement}} newer
   */

  switchInstance(old, newer) {
    console.warn(old.element());
    document.body.style.setProperty('--wp--custom--act-lightbox--duration', '0s');

    newer.show();
    old.close();

    //  document.body.style.removeProperty('--wp--custom--act-lightbox--duration');
    this.instance = newer;
  }

  currentIndex() {
    return this.instances.findIndex(record => record.instance === this.instance);
  }

  attachOpenEvents() {
    document.addEventListener('keydown', this.listenKeydownEvent);
  }

  detachOpenEvents() {
    document.removeEventListener('keydown', this.listenKeydownEvent);
  }

  /**
   *
   * @param {KeyboardEvent} event
   */
  listenKeydownEvent(event) {
    if (!this.isOpen || !Object.values(this.keyCodes).includes(event.code)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();


    switch (event.code) {
      case this.keyCodes.ESC:
        this.close();
        break;
      case this.keyCodes.LEFT:
        this.previous();
        break;
      case this.keyCodes.RIGHT:
        this.next();
    }

  }
}

class Act {

  constructor() {
    this.initHeader();
    this.initZoneOpeners();
    this.initAnimationOnScroll();
    this.createProductSlider();
    this.createFrontpageSlider();
    this.initTabs();
    this.initLightBox();
    this.initSearchPopover();
  }

  initAnimationOnScroll() {
    AOS.init({
      once: true,
    });
  }

  createProductSlider() {

    if (!document.body.classList.contains('single-produit')) {
      return;
    }

    /**  @type {HTMLElement} container **/
    const container = document.querySelector('.product-images.has-slider');

    if (!container) {
      return;
    }

    const element = container.querySelector('.swiper');

    if (!element) {
      return;
    }

    const swiper = new Swiper(element, {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.slider-control-next',
        prevEl: '.slider-control-prev',
      },
    });
  }

  initTabs() {
    document.querySelectorAll('[role=tablist].automatic').forEach(container => {
      new TabsAutomatic(container);
    });
  }

  initHeader() {
    /**  @var {HTMLElement} header **/
    const header = document.querySelector('.branding-header');

    if (!header) {
      return;
    }

    let previous = 0;
    const setHeight = () => {
      const height = header.getBoundingClientRect().height;

      if (height !== previous) {
        document.body.style.setProperty('--wp--custom--header--height', `${height}px`);
        previous = height;
      }
    }
    window.addEventListener('resize', setHeight);
    setHeight();

  }

  initZoneOpeners() {
    document.querySelectorAll('.zone-opener').forEach(button => {

      const targetName = button.getAttribute('aria-controls');
      if (!targetName) {
        return;
      }

      const target = document.getElementById(targetName);
      if (!target) {
        return;
      }

      button.addEventListener('click', () => {

        const isOpen = button.ariaExpanded === 'true';
        const classes = `open-zone-${targetName}`;

        if (isOpen) {
          document.body.classList.remove('zone-open', classes);
          target.classList.remove('is-open');
          button.classList.remove('open');
          button.ariaExpanded = 'false';
        } else {
          document.body.classList.add('zone-open', classes);
          target.classList.add('is-open');
          button.classList.add('open');
          button.ariaExpanded = 'true';
        }
      });
    });
  }

  createFrontpageSlider() {
    if (!document.body.classList.contains('home')) {
      return;
    }

    /**  @type {HTMLElement} container **/
    const element = document.querySelector('.home .page-header .swiper');

    if (!element) {
      return;
    }

    const swiper = new Swiper(element, {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.slider-control-next',
        prevEl: '.slider-control-prev',
      },
    });
  }

  initLightBox() {

    new SimpleLightbox('.header-container .color .thumb', {
      overlayOpacity: .8,
      className: 'color-thumb-preview'
    });

    new SimpleLightbox('.section-technical .color .thumb', {
      overlayOpacity: .8,
      className: 'color-thumb-preview'
    });


    const productGallery = new SimpleLightbox('.single-produit [rel="product-main-gallery"]', {
      overlayOpacity: 1,
      className: 'color-thumb-preview'
    });

    const button = document.querySelector('.single-produit .slider .controls.zoom');

    if (button) {
      button.addEventListener('click', () => productGallery.open())
    }

  }

  initSearchPopover() {
    /**  @type {HTMLElement} button **/
    const button = document.querySelector('.search-trigger');
    if (!button) {
      return;
    }
    const id = button.dataset.templateId;

    if (!id) {
      return;
    }

    /**  @type {HTMLTemplateElement} popover **/
    const template = document.querySelector(`#${id}`);

    if (!template) {
      return;
    }

    /**  @type {HTMLElement} popover **/
    const popover = document.createElement('div');
    popover.id = 'search-popover';
    popover.classList.add('search-popover');
    popover.prepend(template.content);
    document.body.append(popover);

    /**  @type {HTMLInputElement} input **/
    const input = popover.querySelector('input.is-search-input');
    let repaint = null;

    if (input) {
      repaint = () => {
        const w = input.getBoundingClientRect().width;
        document.body.style.setProperty('--wp--custom--search-input--width', `${w}px`);
      }

      document.addEventListener('resize', repaint);
      requestAnimationFrame(repaint);
    }

    button.addEventListener('click', () => {
      button.classList.toggle('is-open');
      popover.classList.toggle('is-open');

      if (repaint) {
        repaint();
      }
    });


    const closeButton = popover.querySelector('.close');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        button.classList.remove('is-open');
        popover.classList.remove('is-open');
      });
    }
  }
}


document.addEventListener("DOMContentLoaded", () => {
  new Act();
});
